import { AuditApiDTO_AuditData } from '../../Pages/manageActivity/ViewActivityAndAudits';
import { getBaseQuery, getBaseUrl } from '../../Utils';
import { createApi } from '@reduxjs/toolkit/query/react';

const baseUrl = `${getBaseUrl()}/API/v3`;
export const ManageActivity = createApi({
  reducerPath: 'ManageActivity',
  baseQuery: getBaseQuery(baseUrl),
  endpoints: (builder) => ({
    GetUsersForActivity: builder.mutation<any, FormData>({
      query: (condition) => ({
        url: '/Users',
        method: 'POST',
        body:condition,
      }),
    }),
 
    GetActivityData: builder.mutation<any, AuditApiDTO_AuditData>({
      query: (auditData) => ({
        url: '/Audit/GetAuditData',
        method: 'POST', 
        body:auditData
      }),
    }),
  }),
});
 
// Export the hooks for the API endpoints
export const { useGetUsersForActivityMutation, useGetActivityDataMutation } = ManageActivity;
